import Routing from "./Routes/Routes.routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const App = () => {
  return (
    <div>
         <ToastContainer />
      <Routing />
  
    </div>
  );
};

export default App;
